/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import HelpIcon from '@mui/icons-material/esm/Help';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import {getHelpURL} from '../../utils/help';

const HelpButton = (props) => {
	const onHelp = () => {
		const context = props.helpContext || 'overview/home';

		window.open(getHelpURL(context), '_blank');
	};

	return (
        <Tooltip enterDelay={300} title={<FormattedMessage id="Tooltip.Help" defaultMessage="Help" />}>
			<div>
				<IconButton onClick={onHelp} size="large">
					<HelpIcon sx={{ color: (theme) => `${theme.components.MuiAppBar.styleOverrides.colorIcon.backgroundColor})` }} />
				</IconButton>
			</div>
		</Tooltip>
    );
}

export default HelpButton;
